/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useContext, useEffect, useState } from "react";
import { Alert, Form, Select, Switch } from "antd";
import MapPropsContext from "../MapPropsContext";
import { Title } from "./Common";
import {
  OPTION_YEAR,
  OPTION_YEAR_SINCE_1988,
  OPTION_MONTH,
} from "../../../utils";
import {
  TI_FROM_MONTH_COMBO,
  TI_FROM_YEAR_COMBO,
  TI_TO_MONTH_COMBO,
  TI_TO_YEAR_COMBO,
  TI_YEAR_DETAIL_SWITCH,
} from "../../../Constants";

/**
 * 기간 조회 - 년도 상세 ( 무선국 현황, 지역별 이동통신 현황)
 */
const { Option } = Select;

const WidgetSelectYearDetail = ({ isSince1988 = false }) => {
  const {
    geojsonExtraParams,
    setGeojsonExtraParams,
    widgetState,
    onChangeWidgetState,
    setChartDivVisible,
  } = useContext(MapPropsContext);

  // selectbox에서 year month 변화 체크
  const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } =
    geojsonExtraParams;

  const [widgetStartYear, setWidgetStartYear] = useState(checkStartYear);
  const [widgetStartYearDetail, setWidgetStartYearDetail] =
    useState(checkEndYear);
  const [widgetStartMonth, setWidgetStartMonth] = useState(checkStartMonth);
  const [widgetEndYear, setWidgetEndYear] = useState(checkEndYear);
  const [widgetEndYearDetail, setWidgetEndYearDetail] = useState(checkEndYear);
  const [widgetEndMonth, setWidgetEndMonth] = useState(checkEndMonth);
  const { isRangeByYear } = widgetState;

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!isRangeByYear) {
      const checkStartYear = widgetStartYear;
      const checkStartMonth = 1;
      const checkEndYear = widgetEndYear;
      const checkEndMonth = 12;
      setGeojsonExtraParams((params) => ({
        ...params,
        checkStartYear,
        checkStartMonth,
        checkEndYear,
        checkEndMonth,
      }));
    } else {
      const checkStartYear = widgetStartYearDetail;
      const checkStartMonth = widgetStartMonth;
      const checkEndYear = widgetEndYearDetail;
      const checkEndMonth = widgetEndMonth;
      setGeojsonExtraParams((params) => ({
        ...params,
        checkStartYear,
        checkStartMonth,
        checkEndYear,
        checkEndMonth,
      }));
    }
  }, [isRangeByYear]);

  /////////////////////////// selectbox 함수 ////////////////////
  // 시작연월이 바뀔 경우
  useEffect(() => {
    if (!isRangeByYear) {
      // 기간조회일 경우
      // 연도 검색은 해당 년의 12월 데이터를 끌어다가 사용합니다.
      const checkStartYear = widgetStartYear;
      const checkStartMonth = 12;
      setGeojsonExtraParams((params) => ({
        ...params,
        checkStartYear,
        checkStartMonth,
      }));
    } else {
      const checkStartYear = widgetStartYearDetail;
      const checkStartMonth = widgetStartMonth;
      setGeojsonExtraParams((params) => ({
        ...params,
        checkStartYear,
        checkStartMonth,
      }));
    }
  }, [widgetStartYear, widgetStartYearDetail]);

  // 끝연월이 바뀔 경우
  useEffect(() => {
    if (!isRangeByYear) {
      // 기간조회일 경우
      // 연도 검색은 해당 년의 12월 데이터를 끌어다가 사용합니다.
      const checkEndYear = widgetEndYear;
      const checkEndMonth = 12;
      setGeojsonExtraParams((params) => ({
        ...params,
        checkEndYear,
        checkEndMonth,
      }));
    } else {
      const checkEndYear = widgetEndYearDetail;
      const checkEndMonth = widgetEndMonth;
      setGeojsonExtraParams((params) => ({
        ...params,
        checkEndYear,
        checkEndMonth,
      }));
    }
  }, [widgetEndYear, widgetEndYearDetail]);

  // 시작월이 바뀔 경우
  useEffect(() => {
    const checkStartMonth = widgetStartMonth;
    setGeojsonExtraParams((params) => ({ ...params, checkStartMonth }));
  }, [widgetStartMonth]);
  // 끝월이 바뀔 경우
  useEffect(() => {
    const checkEndMonth = widgetEndMonth;
    setGeojsonExtraParams((params) => ({ ...params, checkEndMonth }));
  }, [widgetEndMonth]);

  return (
    <Form.Item>
      <Title
        extra={
          <Switch
            defaultChecked={isRangeByYear}
            onChange={(checked) => {
              onChangeWidgetState({
                target: { name: "isRangeByYear", value: checked },
              });
            }}
            unCheckedChildren={"기간조회"}
            checkedChildren={"년도 상세"}
            tabIndex={TI_YEAR_DETAIL_SWITCH}
          />
        }
      >
        조회방식
      </Title>
      <div hidden={isRangeByYear} style={{ textAlign: "center" }}>
        {/*<Divider orientation="left">기간 조회</Divider>*/}
        <Select
          defaultValue={checkStartYear}
          onChange={(value) => {
            setWidgetStartYear(value);
            if (getIsCorrectYear(value, widgetEndYear) === false) {
              alert("검색시작일자가 종료일자보다 이후일수 없습니다.");
              setErrorMessage("검색시작일자가 종료일자보다 이후일수 없습니다.");
              setChartDivVisible(true);
              return false;
            } else {
              setChartDivVisible(false);
              setErrorMessage(null);
            }
          }}
          style={{ width: "48%" }}
          tabIndex={TI_FROM_YEAR_COMBO}
        >
          {!isSince1988 &&
            OPTION_YEAR().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
          {isSince1988 &&
            OPTION_YEAR_SINCE_1988().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        </Select>
        ~
        <Select
          defaultValue={checkEndYear}
          onChange={(value) => {
            setWidgetEndYear(value);
            if (getIsCorrectYear(widgetStartYear, value) === false) {
              alert("검색종료일자가 시작일자보다 이전일수 없습니다.");
              setErrorMessage("검색종료일자가 시작일자보다 이전일수 없습니다.");
              setChartDivVisible(true);
              return false;
            } else {
              setChartDivVisible(false);
              setErrorMessage(null);
            }
            // setWidgetEndYear(value)
          }}
          style={{ width: "48%" }}
          tabIndex={TI_FROM_MONTH_COMBO}
        >
          {!isSince1988 &&
            OPTION_YEAR().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
          {isSince1988 &&
            OPTION_YEAR_SINCE_1988().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        </Select>
      </div>
      <div hidden={!isRangeByYear} style={{ textAlign: "center" }}>
        {/*<Divider orientation="left">년도 상세</Divider>*/}
        <Select
          tabIndex={TI_FROM_YEAR_COMBO}
          defaultValue={checkEndYear}
          onChange={(value) => {
            setWidgetStartYearDetail(value);
            if (
              getIs24Month(
                value,
                widgetStartMonth,
                widgetEndYearDetail,
                widgetEndMonth
              ) === false
            ) {
              alert(
                "검색시작일자가 종료일자보다 이후이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setErrorMessage(
                "검색시작일자가 종료일자보다 이후이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setChartDivVisible(true);
              return false;
            } else {
              setChartDivVisible(false);
              setErrorMessage(null);
            }
          }}
          style={{ width: "30%" }}
        >
          {!isSince1988 &&
            OPTION_YEAR().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
          {isSince1988 &&
            OPTION_YEAR_SINCE_1988().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        </Select>
        <Select
          tabIndex={TI_FROM_MONTH_COMBO}
          defaultValue={checkStartMonth}
          onChange={(value) => {
            setWidgetStartMonth(value);
            if (
              getIs24Month(
                widgetStartYearDetail,
                value,
                widgetEndYearDetail,
                widgetEndMonth
              ) === false
            ) {
              alert(
                "검색시작일자가 종료일자보다 이후이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setErrorMessage(
                "검색시작일자가 종료일자보다 이후이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setChartDivVisible(true);
              return false;
            } else {
              setChartDivVisible(false);
              setErrorMessage(null);
            }
          }}
          style={{ width: "18%" }}
        >
          {!isSince1988 &&
            OPTION_MONTH().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
          {isSince1988 &&
            OPTION_MONTH().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        </Select>
        ~
        <Select
          tabIndex={TI_TO_YEAR_COMBO}
          defaultValue={checkEndYear}
          onChange={(value) => {
            setWidgetEndYearDetail(value);
            if (
              getIs24Month(
                widgetStartYearDetail,
                widgetStartMonth,
                value,
                widgetEndMonth
              ) === false
            ) {
              alert(
                "검색종료일자가 시작일자보다 이전이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setErrorMessage(
                "검색종료일자가 시작일자보다 이전이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setChartDivVisible(true);
              return false;
            } else {
              setChartDivVisible(false);
              setErrorMessage(null);
            }
          }}
          style={{ width: "30%" }}
        >
          {!isSince1988 &&
            OPTION_YEAR().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
          {isSince1988 &&
            OPTION_YEAR_SINCE_1988().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        </Select>
        <Select
          tabIndex={TI_TO_MONTH_COMBO}
          defaultValue={checkEndMonth}
          onChange={(value) => {
            setWidgetEndMonth(value);
            if (
              getIs24Month(
                widgetStartYearDetail,
                widgetStartMonth,
                widgetEndYearDetail,
                value
              ) === false
            ) {
              alert(
                "검색종료일자가 시작일자보다 이전이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setErrorMessage(
                "검색종료일자가 시작일자보다 이전이거나 24개월을 초과하여 조회할 수 없습니다."
              );
              setChartDivVisible(true);
              return false;
            } else {
              setChartDivVisible(false);
              setErrorMessage(null);
            }
          }}
          style={{ width: "18%" }}
        >
          {!isSince1988 &&
            OPTION_MONTH().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
          {isSince1988 &&
            OPTION_MONTH().map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        </Select>
      </div>
      {errorMessage && (
        <Alert message={errorMessage} type={"error"} style={{ marginTop: 8 }} />
      )}
    </Form.Item>
  );
};

const getIs24Month = (startYear, startMonth, endYear, endMonth) => {
  const intStartYear = parseInt(startYear);
  const intStartMonth = parseInt(startMonth);
  const intEndYear = parseInt(endYear);
  const intEndMonth = parseInt(endMonth);

  const strStartMonth =
    startMonth < 10 ? "0" + startMonth : startMonth.toString();
  const strEndMonth = endMonth < 10 ? "0" + endMonth : endMonth.toString();

  const strStart = parseInt(startYear.toString() + strStartMonth);
  const strEnd = parseInt(endYear.toString() + strEndMonth);

  if (strStart > strEnd) {
    return false;
  }

  const monthRange = intEndMonth - intStartMonth;
  const yearMonthRange = (intEndYear - intStartYear) * 12 + monthRange;
  if (yearMonthRange <= 24) {
    return true;
  }
  return false;
};

const getIsCorrectYear = (startYear, endYear) => {
  const intStartYear = parseInt(startYear);
  const intEndYear = parseInt(endYear);

  if (intStartYear > intEndYear) {
    return false;
  }
  return true;
};

export default WidgetSelectYearDetail;
